import { SANITY_CARRIERS_FETCHED, LOG_OUT } from "../types";

const INITIAL_STATE = [];

export default function sanityCarriers(state = INITIAL_STATE, action = {}) {
  switch (action.type) {
    case SANITY_CARRIERS_FETCHED:
      return action.data;
    case LOG_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}
